import React from 'react';
import PropTypes from 'prop-types';
import Form from './Form'
import Notification from '@deporvillage/notification-component';
import Picture from '@deporvillage/picture-component';
import { I18n } from '@deporvillage/utils-library-component';

import styles from './Register.module.scss';
import SocailRegister from './SocialRegister';

/* istanbul ignore next */
const scrollToBottom = (elem) =>
    elem.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'end' });

const Register = ({ customerData, onChange, onRegister, error }) => {
    const { firstName, lastName, gender, email, password, passwordConfirmation, isAccepted } =
        customerData;

    const genderOptions = [
        {
            key: 'form.label.gender',
            value: '',
            disabled: true,
        },
        {
            key: 'form.gender.male',
            value: 'M',
        },
        {
            key: 'form.gender.female',
            value: 'F',
        },
        {
            key: 'form.gender.other',
            value: 'O',
        },
    ];

    const registerError = React.useRef(null);

    const handleOnChange = (input) => onChange && onChange(input, customerData);
    const handleOnRegister = (e) => {
        e.preventDefault();
        onRegister && onRegister(customerData);
    };

    React.useEffect(() => {
        if (error && registerError.current) {
            scrollToBottom(registerError.current);
        }
    }, [error]);

    return (
        <div className={styles['register-component']}>
            <div className={styles['logo']}>
                <a href='/' title='Deporvillage'>
                    <Picture src={'/static/default/deporvillage_logo.png'} height={77} lazy />
                </a>
            </div>

            <SocailRegister />

            <form autoComplete={'off'} className={styles['form-component']} id={'register-form'}>
                <div className={styles['title-form']}>
                    <I18n>register.register_popup.title.register</I18n>
                </div>
                <Form
                    {...firstName}
                    onChange={(value) => handleOnChange({ ...firstName, value })}
                />
                <Form {...lastName} onChange={(value) => handleOnChange({ ...lastName, value })} />
                {gender ? (
                    <Form
                        {...{ ...gender, options: genderOptions }}
                        onChange={(value) => handleOnChange({ ...gender, value })}
                    />
                ) : null}
                <Form {...email} onChange={(value) => handleOnChange({ ...email, value })} />
                <Form {...password} onChange={(value) => handleOnChange({ ...password, value })} />
                <Form
                    {...passwordConfirmation}
                    onChange={(value) => handleOnChange({ ...passwordConfirmation, value })}
                />
                <div className={`${styles['minimum-character-info']}`}>
                    <span className={`${styles['icon']} icon icon-info-outline`} />
                    <span>
                        <I18n>form.generic.minimum_character</I18n>
                    </span>
                </div>
                <Form
                    {...isAccepted}
                    onChange={(value) => handleOnChange({ ...isAccepted, value })}
                />
                <button onClick={handleOnRegister} className={styles['button']}>
                    <I18n>register.register_popup.register</I18n>
                </button>

                <div className={styles['required']}>
                    * <I18n>form.generic.required_fields</I18n>
                </div>
            </form>
            {error ? (
                <div ref={registerError} className={styles['register-error']}>
                    <Notification
                        message={<I18n>register.register_popup.error</I18n>}
                        type='error'
                    />
                </div>
            ) : null}
        </div>
    );
};

Register.propTypes = {
    customerData: PropTypes.shape({
        firstName: PropTypes.shape({
            id: PropTypes.string,
            type: PropTypes.string,
            label: PropTypes.string,
            value: PropTypes.string,
            error: PropTypes.string,
            validate: PropTypes.array,
        }),
        lastName: PropTypes.shape({
            id: PropTypes.string,
            type: PropTypes.string,
            label: PropTypes.string,
            value: PropTypes.string,
            error: PropTypes.string,
            validate: PropTypes.array,
        }),
        gender: PropTypes.shape({
            id: PropTypes.string,
            type: PropTypes.string,
            label: PropTypes.string,
            value: PropTypes.string,
            error: PropTypes.string,
            validate: PropTypes.array,
        }),
        email: PropTypes.shape({
            id: PropTypes.string,
            type: PropTypes.string,
            label: PropTypes.string,
            value: PropTypes.string,
            error: PropTypes.string,
            validate: PropTypes.array,
        }),
        password: PropTypes.shape({
            id: PropTypes.string,
            type: PropTypes.string,
            label: PropTypes.string,
            value: PropTypes.string,
            error: PropTypes.string,
            validate: PropTypes.array,
        }),
        passwordConfirmation: PropTypes.shape({
            id: PropTypes.string,
            type: PropTypes.string,
            label: PropTypes.string,
            value: PropTypes.string,
            error: PropTypes.string,
            validate: PropTypes.array,
        }),
        isAccepted: PropTypes.shape({
            id: PropTypes.string,
            type: PropTypes.string,
            label: PropTypes.string,
            value: PropTypes.bool,
            validate: PropTypes.array,
        }),
    }),
    onRegister: PropTypes.func,
    onChange: PropTypes.func,
    error: PropTypes.bool,
};

export default Register;
